import { makeStyles } from "@material-ui/core";

export const useReportManagementPageStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexFlow: 'column',
  }
}));
